<template>
  <timeline-item type="e-mail" :date="message.date_sent">
    <template v-slot:title>{{ message.title }}</template>
    <template v-slot:actions>
      <a class="btn btn-sm m-btn m-btn--pill m-btn--custom btn-outline-ls" @click="openModal">
        Zobacz wiadomość
      </a>
      <b-modal v-model="isModalOpened" @shown="reloadIframe"
               :title="message.title"
               :ok-only="true"
               centered
               size="lg"
               ok-title="Zamknij"
               ok-variant="default"
               :lazy="true">
        <iframe ref="frame" :srcdoc=message.content
        ></iframe>
      </b-modal>
    </template>
  </timeline-item>
</template>

<script>
import TimelineItem from '@/components/timeline/TimelineItem';

export default {
  name: "EmailMessage",
  components: {TimelineItem},
  props: ['message'],
  data() {
    return {
      isModalOpened: false
    }
  },
  methods: {
    openModal() {
      this.isModalOpened = true
    },
    reloadIframe(){
      this.$refs.frame.contentWindow.location.reload();
      this.message.content;
    }
  },
}
</script>

<style>

.modal-lg{
  max-width: 1000px !important;
}
.modal .modal-content .modal-body {
  overflow: auto;
}
iframe{
  height: 600px;
  border: 0;
}

@media (max-height: 800px) {
  iframe{
    height: 400px
  }
}
@media (max-height: 600px) {
  iframe{
    height: 300px
  }
}

</style>
